<script setup lang="ts">
/**
 * Entry page for the flow
 * --------------------------------------------------------------------------------------------------
 * This page is SERVER-SIDE-RENDERED and serves as a fast-loaded entry point
 * to the product flow. it resets all stores.
 */
definePageMeta({
    layout: 'empty',
    path: '/booking/jtp/start',
    title: 'offerFlow.splashMessage.jtp',
});

onMounted(() => {
    useResetStores().resetOfferFlow();
    useStartFreshFlow().startFreshFlow(productConfigJtp);
});
</script>

<template>
    <IntroLoader />
</template>
